import { type Theme as GingaTheme, rebrandTheme as stoneRebrandGingaTheme } from '@dlpco/ginga-stone'

export function useGingaTheme(): GingaTheme {
  return stoneRebrandGingaTheme
}
